"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _container = _interopRequireDefault(require("../container"));

var _icon = _interopRequireDefault(require("../icon"));

var _index = _interopRequireDefault(require("./index.scss"));

var ESCAPE_KEYCODE = 27;

var Modal = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Modal, _Component);

  function Modal() {
    var _this;

    (0, _classCallCheck2["default"])(this, Modal);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Modal).call(this));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyDown", function (e) {
      var onDismissButtonClick = _this.props.onDismissButtonClick;

      if (e.keyCode === ESCAPE_KEYCODE) {
        // Escape cancels the modal.
        onDismissButtonClick();
      }
    });
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          onDismissButtonClick = _this$props.onDismissButtonClick,
          children = _this$props.children,
          containerSize = _this$props.containerSize,
          internalDismiss = _this$props.internalDismiss,
          isOpen = _this$props.isOpen;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_index["default"].Modal, (0, _defineProperty2["default"])({}, _index["default"].modalOpen, isOpen), className)
      }, _react["default"].createElement(_container["default"], {
        type: containerSize,
        className: _index["default"].modalContents
      }, _react["default"].createElement("button", {
        className: internalDismiss ? _index["default"].internalDismiss : _index["default"].externalDismiss,
        "aria-label": "Dismiss modal",
        onClick: onDismissButtonClick
      }, _react["default"].createElement(_icon["default"], {
        type: "cross",
        className: _index["default"].icon
      })), children));
    }
  }]);
  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  onDismissButtonClick: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].node,
  containerSize: _propTypes["default"].oneOf(['small', 'medium', 'large']),
  internalDismiss: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
Modal.defaultProps = {
  containerSize: 'medium',
  internalDismiss: false
};
var _default = Modal;
exports["default"] = _default;